module.exports = __webpack_public_path__ + "static/media/topolompopo.ca5854bd.jpg";